import Flickity from 'flickity'

jQuery(document).ready(function ($) {
	$(".photo-carousel-slider").each(function () {
		if ($(this).find(".slide").length > 1) {
			let flkty = new Flickity(this, {
				wrapAround: true,
				pageDots: true,
				cellAlign: "center",
				accessibility: false,
				draggable: false
			});

			flkty.on("select", function (index) {
				let slide = $(".photo-carousel-slider .slide")
					.eq(index)
					.attr("data-slide");

				$(".photo-carousel-background.active").removeClass("active");
				$('.photo-carousel-background[data-slide="' + slide + '"]').addClass(
					"active"
				);
			});
		}
	});
});